<script>
    import Header from '../header.svelte';
    import { push, querystring } from 'svelte-spa-router';
    import IFTAInput from '../../utils/iftainput.svelte';
    import { api_host, company_details_store, business_hours_store, user_store, places_store } from '../../stores.js';
    import { init_data } from '../../init.js';
    import { state_codes } from '../../globals.js';
    import { onMount } from 'svelte';
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from '../../utils/toast_message.js';
    import { handle_not_subscribed } from '../../utils/format.js';
    import Swal from "sweetalert2";


    let is_busy = false;
    let content_title = "Settings - Company";
    let myself = {};
    let places = {};
    let tax_rates = [];
    let is_new = false;

    const validate_tax = (tax_rate) => {
        if (!tax_rate.deleted) {
            if (tax_rate.name.trim().length == 0) {
                toast_message(false, "Tax name is required field.", 2000);
                return false;
            }
            if (!tax_rate.rate || tax_rate.rate <= 0 || tax_rate.rate >= 100) {
                toast_message(false, "Tax rate is not valid.", 2000);
                return false;
            }
        }
        
        return true;
    }

    const add_tax_rate = () => {
        tax_rates.push({
            name: '',
            rate: 0,
            comments: '',
            deleted: false
        });
        tax_rates = tax_rates;
    };
    const delete_tax_rate = (tax_rate) => {
        tax_rate.deleted = true;
        tax_rates = tax_rates;
    };

    user_store.subscribe(value => {
        myself = value;
    });
    places_store.subscribe(value => {
        places = value;
    });

    onMount(() => {
        const params = new URLSearchParams($querystring);
        if (params.has('reg')) {
            is_new = (params.get('reg') === 'first');
            if (is_new) {
                toast_message(true, 'Thank you for signing up House of Yards App!', 3000);

                // push('#/Settingscompany');
            }
        }
    });

    let fields = [
        {
            "index": 0,
            "group": "contact_details",
            "type": "text",
            "label": "Business Name",
            "value": "",
            "placeholder": "eg. HOY",
            "name": "company_settings[business_name]",
            "disabled": myself.role !== 'landscaper',
            "validation_function": () => {
                if (fields[0].value.length) {
                    if (fields[0].value.length > 22) {
                        fields[0]['show_error'] = true;
                        fields[0]['error_text'] = 'Must contain at least one letter, maximum 22 characters';
                        return false;
                    }
                    fields[0]['show_error'] = false;
                    return true;
                } else {
                    fields[0]['show_error'] = true;
                    fields[0]['error_text'] = 'Invalid Business Name';
                    return false;
                }
            }
        }, {
            "index": 1,
            "group": "contact_details",
            "type": "text",
            "label": "Phone",
            "value": "",
            "placeholder": "eg. 000-000-0000",
            "name": "company_settings[phone]",
            "disabled": myself.role !== 'landscaper',
            'change_function': (evt) => {
                var x = evt.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                evt.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            "validation_function": () => {
                const phoneformat = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (fields[1].value.match(phoneformat)) {
                    fields[1]['show_error'] = false;
                    return true;
                } else {
                    fields[1]['show_error'] = true;
                    fields[1]['error_text'] = 'Invalid phone number';
                    return false;
                }
            }
        }, {
            "index": 2,
            "group": "contact_details",
            "type": "text",
            "label": "Email",
            "value": "",
            "placeholder": "eg. bsimpson@mailinator.com",
            "name": "company_settings[email]",
            "disabled": myself.role !== 'landscaper',
            "validation_function": () => {
                const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (fields[2].value.match(mailformat)) {
                    fields[2]['show_error'] = false;
                    return true;
                } else {
                    fields[2]['show_error'] = true;
                    fields[2]['error_text'] = 'Invalid email';
                    return false;
                }
            }
        }, {
            "index": 3,
            "group": "address_details",
            "type": "text",
            "label": "Address",
            "value": "",
            "placeholder": "eg. 3251 Oakdale Avenue, Tampa, Florida",
            "name": "company_settings[address]",
            "disabled": myself.role !== 'landscaper',
            "validation_function": () => {
                if (fields[3].value.length) {
                    fields[3]['show_error'] = false;
                    return true;
                } else {
                    fields[3]['show_error'] = true;
                    fields[3]['error_text'] = 'Invalid Address';
                    return false;
                }
            }
        }, {
            "index": 4,
            "group": "taxrate",
            "type": "text",
            "label": "Tax Rate (%)",
            "value": "",
            "placeholder": "eg. 30",
            "name": "company_settings[taxrate]",
            "disabled": myself.role !== 'landscaper',
            "validation_function": () => {
                if (parseFloat(fields[4].value) >= 0) {
                    fields[4]['show_error'] = false;
                    return true;
                } else {
                    fields[4]['show_error'] = true;
                    fields[4]['error_text'] = 'Invalid Tax Rate';
                    return false;
                }
            }
        }, {
            "index": 5,
            "group": "owner",
            "type": "text",
            "label": "First Name",
            "value": "",
            "placeholder": "eg. John",
            "name": "company_settings[first_name]",
            "disabled": myself.role !== 'landscaper',
            "validation_function": () => {
                if (fields[5].value.length) {
                    fields[5]['show_error'] = false;
                    return true;
                } else {
                    fields[5]['show_error'] = true;
                    fields[5]['error_text'] = 'Invalid First Name';
                    return false;
                }
            }
        }, {
            "index": 6,
            "group": "owner",
            "type": "text",
            "label": "Last Name",
            "value": "",
            "placeholder": "eg. Smith",
            "name": "company_settings[last_name]",
            "disabled": myself.role !== 'landscaper',
            "validation_function": () => {
                if (fields[6].value.length) {
                    fields[6]['show_error'] = false;
                    return true;
                } else {
                    fields[6]['show_error'] = true;
                    fields[6]['error_text'] = 'Invalid Last Name';
                    return false;
                }
            }
        }, {
            "index": 7,
            "group": "address_details",
            "type": "text",
            "label": "City",
            "value": "",
            "placeholder": "eg. 3251 Oakdale Avenue, Tampa, Florida",
            "name": "company_settings[city]",
            "disabled": myself.role !== 'landscaper',
            "validation_function": () => {
                if (fields[7].value.length) {
                    fields[7]['show_error'] = false;
                    return true;
                } else {
                    fields[7]['show_error'] = true;
                    fields[7]['error_text'] = 'Invalid City';
                    return false;
                }
            }
        }, {
            "index": 8,
            "group": "address_details",
            "type": "select",
            "label": "State",
            "value": "Arizona",
            "select_options": Object.keys(state_codes),
            "name": "job[state]",
            "disabled": myself.role !== 'landscaper',
            "change_function": (evt) => {
                if (evt.target.value) {
                    fields[8]['show_error'] = false;
                } else {
                    fields[8]['show_error'] = true;
                    fields[8]['error_text'] = 'Invalid State';
                }
            },
            "validation_function": () => {
                if (fields[8].value.length) {
                    fields[8]['show_error'] = false;
                    return true;
                } else {
                    fields[8]['show_error'] = true;
                    fields[8]['error_text'] = 'Invalid State';
                    return false;
                }
            }
        }, {
            "index": 9,
            "group": "address_details",
            "type": "text",
            "label": "Zip Code",
            "value": "",
            "placeholder": "Optional (eg. 85001)",
            "name": "job[zipcode]",
            "disabled": myself.role !== 'landscaper',
            "validation_function": () => {
                const zipformat = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                if (fields[9].value.length == 0) return true;
                if (fields[9].value.match(zipformat)) {
                    fields[9]['show_error'] = false;
                    return true;
                } else {
                    fields[9]['show_error'] = true;
                    fields[9]['error_text'] = 'Invalid zipcode';
                    return false;
                }
            }
        }
    ];

    let timezone = '';
    let country = '';
    let business_hours = [];
    let avatar = '';

    company_details_store.subscribe(value => {
        fields[0].value = value.business_name;
        fields[1].value = value.phone;
        fields[2].value = value.email;
        fields[3].value = value.address;
        fields[4].value = value.tax_rate;
        fields[5].value = value.first_name;
        fields[6].value = value.last_name;
        fields[7].value = value.city;
        fields[8].value = value.state;
        fields[9].value = value.zipcode;
        timezone = value.timezone;
        country = value.country;
        avatar = value.avatar;
        tax_rates = value.tax_rates ?? [];
    });

    business_hours_store.subscribe(value => {
        let temp_business_hours = [];
        for (let i = 0; i < value.length; i ++) {
            const business_hour = value[i];
            temp_business_hours.push({
                day: business_hour.day,
                start: business_hour.start,
                end: business_hour.end
            });
        }
        business_hours = temp_business_hours;
    });

    const validateForm = () => {
        let is_valid = true;
        fields.forEach(field => {
            if (!field.validation_function()) { is_valid = false; }
        });
        tax_rates.forEach(tax_rate => {
            is_valid = is_valid && validate_tax(tax_rate);
        });
        return is_valid;
    }
    const updateCompanyDetails = async () => {
        if (!myself['is_subscribed'] !== undefined && !myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }
        if (validateForm()) {
            is_busy = true;
            toast_message(true, 'Saving setting...', 2000);
            const payload = {
                business_name: fields[0].value,
                phone: fields[1].value,
                email: fields[2].value,
                address: fields[3].value,
                city: fields[7].value,
                state: fields[8].value,
                zipcode: fields[9].value,
                tax_rate: fields[4].value,
                first_name: fields[5].value,
                last_name: fields[6].value,
                timezone,
                country,
                business_hours,
                avatar,
                tax_rates
            };
            const { auth_type, auth_token, domain_code } = getToken();
            const res = await doFetch(
                api_host + `/api/landscaper/update/company_detail`,
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                // toast_message(true, 'Get started by setting up your company info.', 2000);
                init_data('company_details');
                init_data('myself');
                setTimeout(() => {
                    console.log('is_new', is_new);
                    if (is_new) {
                        push('#/Places?is_new=first');
                        // toast_message(true, 'Add service cities/state in Places', 3000);
                    }
                }, 1000);
            } else {
                toast_message(false, res.msg || 'Updating failed', 2000);
            }
            is_busy = false;
        }
    }

	let fileinput;
	const onFileSelected =(e)=>{
        let image = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = e => {
            avatar = e.target.result;
        };
    }
</script>

<Header title="{content_title}" bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="section pricingsettings">
        <div class="sectionsubtitle">Company Details</div>
        <div class="ff formrow featuresettings">
            {#each fields.filter((e) => e.group === "contact_details") as nf}
            <IFTAInput 
                type={(nf.type !== undefined) ? nf.type : ""} 
                label={(nf.label !== undefined) ? nf.label : ""} 
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                readonly={nf.readonly}
                disabled={nf.disabled}
                name={nf.name}
                show_error={nf.show_error}
                error_text={nf.error_text}
                bind:value={nf.value}
                bind:change_function={nf.change_function}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
            />
            {/each}
        </div>
        <div class="ff formrow featuresettings">
            {#each fields.filter((e) => e.group === "address_details") as nf}
            <IFTAInput 
                type={(nf.type !== undefined) ? nf.type : ""} 
                label={(nf.label !== undefined) ? nf.label : ""} 
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                readonly={nf.readonly}
                disabled={nf.disabled}
                name={nf.name}
                show_error={nf.show_error}
                error_text={nf.error_text}
                bind:value={nf.value}
                bind:change_function={nf.change_function}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
            />
            {/each}
        </div>
    </div>

    <div class="section pricingsettings">
        <div class="sectionsubtitle">Company Logo</div>
        <div id="app">
            {#if avatar}
                <div style='position: relative;'>    
                    <img class="avatar" src="{avatar}" alt="logo" />
                    {#if myself.role === 'landscaper'}
                        <i class='fas fa-trash-alt' style='position: absolute;top: 20px;right: -50px;cursor: pointer;color: #ab003c;' on:click={() => {
                            Swal.fire({
                                title: 'Delete logo?',
                                buttonsStyling: true,
                                confirmButtonClass: "button",
                                confirmButtonText: 'OK',
                                cancelButtonText: "Cancel",
                                showCancelButton: true,
                                icon: "warning"
                            }).then((e) => {
                                if (e.isConfirmed) {
                                    avatar = '';
                                }
                            });
                        }}></i>
                    {/if}
                </div>
            {:else}
                <!-- <img class="avatar" src="//via.placeholder.com/150" alt="logo" />  -->
            {/if}
            <br />
            {#if myself.role === 'landscaper'}
                <img class="upload" src="https://static.thenounproject.com/png/625182-200.png" alt="" on:click={()=>{fileinput.click();}} />
                <div class="chan" on:click={() => { fileinput.click(); }}>Choose Image</div>
                <input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change={(e)=>onFileSelected(e)} bind:this={fileinput} />
            {/if}
        </div>
    </div>

    <!-- <div class="section pricingsettings">
        <div class="sectionsubtitle">Business Hours</div>
        <div class="ff rowwrap featuresettings">
            <table style="margin-left: 10px;margin-bottom: 20px;">
                <tr>
                    <th style="width: 120px;">Day</th>
                    <th style="width: 100px;">Start</th>
                    <th>End</th>
                </tr>
                {#each business_hours as business_hour_item}
                    <tr>
                        <td>{business_hour_item.day}</td>
                        <td>
                            {#if business_hour_item.start !== 'off'}
                                <select bind:value={business_hour_item.start} disabled={myself.role === 'manager'}>
                                    {#each Array(24) as _, row}
                                        <option value={`${row > 12 ? row - 12 : row}${row > 12 ? 'PM' : 'AM'}`}>
                                            {`${row > 12 ? row - 12 : row}${row > 12 ? 'PM' : 'AM'}`}
                                        </option>
                                    {/each}
                                    <option value='off'>-</option>
                                </select>
                            {:else}
                                <span style="margin-left: 30px;font-weight: bold;">-</span>
                            {/if}
                        </td>
                        <td>
                            {#if business_hour_item.end !== 'off'}
                                <select bind:value={business_hour_item.end} disabled={myself.role === 'manager'}>
                                    {#each Array(24) as _, row}
                                        <option value={`${row > 12 ? row - 12 : row}${row > 12 ? 'PM' : 'AM'}`}>
                                            {`${row > 12 ? row - 12 : row}${row > 12 ? 'PM' : 'AM'}`}
                                        </option>
                                    {/each}
                                    <option value='off'>-</option>
                                </select>
                            {:else}
                                <span style="margin-left: 30px;font-weight: bold;">-</span>
                            {/if}
                        </td>
                    </tr>
                {/each}
            </table>
        </div>
    </div> -->
    
    <div class="section pricingsettings">
        <div class="sectionsubtitle">Regional Settings</div>
        <div class="ff rowwrap featuresettings">
            <IFTAInput
                type="select"
                label="Country"
                disabled={myself.role !== 'landscaper'}
                bind:value={country}
                select_options={["United States", "Canada"]}
            />

            <IFTAInput 
                type="select"
                label="Time Zone"
                style="width: 370px;"
                disabled={myself.role !== 'landscaper'}
                bind:value={timezone}
                select_options={["(GMT−08:00) Pacific Time (US & Canada)", "(GMT −07:00) Mountain Time (US & Canada)", "(GMT −06:00) Central Time (US & Canada)", "(GMT −05:00) Eastern Time (US & Canada)"]}
            />
        </div> 
    </div>

    <div class="section taxsettings">
        <div class="sectionsubtitle">Tax Rates</div>
        <div class="ff rowwrap featuresettings">
            <div class="d-flex flex-column">
                <table>
                    <tr><th>Tax name</th><th>Tax rate (%)</th><th>Comments</th><th></th></tr>
                    {#each tax_rates.filter(t => !t.deleted) as tax_rate, index }
                    <tr>
                        <td><input type="text" bind:value={tax_rate.name} style="width: 150px;" /></td>
                        <td><input type="number" bind:value={tax_rate.rate} style="width: 100px;" /></td>
                        <td><textarea rows=1 bind:value={tax_rate.comments} style="width: 200px; border-radius: 4px; margin-top: 6px;"></textarea></td>
                        <td>
                            <i class='fas fa-trash-alt' style='cursor: pointer;color: #ab003c;' on:click={() => {
                                Swal.fire({
                                    title: 'Delete this tax?',
                                    buttonsStyling: true,
                                    confirmButtonClass: "button",
                                    confirmButtonText: 'OK',
                                    cancelButtonText: "Cancel",
                                    showCancelButton: true,
                                    icon: "warning"
                                }).then((e) => {
                                    if (e.isConfirmed) {
                                        delete_tax_rate(tax_rate);
                                    }
                                });
                            }}></i>
                        </td>
                    </tr>
                    {/each}
                </table>
                <div class="d-flex mt-2 ml-1">
                    <button class="save" on:click={add_tax_rate}><i class="fa-plus" style="font-style: normal;"></i> New</button>
                </div>

            </div>
        </div> 
    </div>

    <!-- <div class="section pricingsettings">
        <div class="sectionsubtitle">Tax Settings</div>
        <div class="ff rowwrap featuresettings">
            {#each fields.filter((e) => e.group === "taxrate") as nf}
            <IFTAInput 
                type={(nf.type !== undefined) ? nf.type : ""} 
                label={(nf.label !== undefined) ? nf.label : ""} 
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                readonly={nf.readonly}
                disabled={nf.disabled}
                name={nf.name}
                show_error={nf.show_error}
                error_text={nf.error_text}
                bind:value={nf.value}
                bind:change_function={nf.change_function}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
            />
            {/each}
        </div> 
    </div> -->

    <div class="buttonholder">
        {#if myself.role === 'landscaper'}
            <button class="savebutton" on:click={() => { updateCompanyDetails(); }} >
                <i class="far fa-save"></i> Save Settings
            </button>
        {/if}
    </div>
</div>


<style>
	#app {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-flow: column;
    }
	.upload {
		display: flex;
	    height: 50px;
		width: 50px;
		cursor: pointer;
	}
	.avatar {
		display: flex;
		height: 150px;
	}
    .section {
        margin-top: 15px;
    }
    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
    }
    .buttonholder button.savebutton {
        color: white;
        background-color: #357a38;
    }
    :global(.rowwrap .group) {
        min-width: 300px;
        max-width: 300px;
    }
    .formrow {
        padding: 0px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    table td, table th {
        padding-left: 4px;
        padding-right: 4px;
    }
    .featuresettings {
        overflow-x: scroll;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.rowwrap .group) {
            min-width: 100%;
            max-width: 100%;
        }
    }
</style>